export const notFoundGrouspsStyle = {
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const addUserGroupsListStyle = {
  border: 1,
  borderColor: 'divider',
  borderRight: 0,
  borderLeft: 0,
  '&:hover': { backgroundColor: '#6582a40d' },
};

export const containedButtonStyle = {
  padding: '6px 16px',
  width: 'auto',
  height: '36px',
  lineHeight: 'normal',
  '@media (max-width: 1728px)': {
    height: '28px',
    padding: '0px 8px',
    top: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  color: 'white',
};